// Suggestion lists for the vehicle-detail fields (Year / Make / Model / Color).
// These power <datalist> autocompletes: the user can pick a suggestion or still
// type anything custom. Kept local (no external API) so it works offline.

// Years: this year (+1 for next-year models) down to 1990.
export const VEHICLE_YEARS = (() => {
  const now = new Date().getFullYear() + 1;
  const out = [];
  for (let y = now; y >= 1990; y--) out.push(String(y));
  return out;
})();

// Common makes sold in the US market.
export const VEHICLE_MAKES = [
  'Acura', 'Alfa Romeo', 'Audi', 'BMW', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler',
  'Dodge', 'Fiat', 'Ford', 'Genesis', 'GMC', 'Honda', 'Hyundai', 'Infiniti', 'Jaguar',
  'Jeep', 'Kia', 'Land Rover', 'Lexus', 'Lincoln', 'Mazda', 'Mercedes-Benz', 'Mini',
  'Mitsubishi', 'Nissan', 'Polestar', 'Porsche', 'Ram', 'Rivian', 'Subaru', 'Tesla',
  'Toyota', 'Volkswagen', 'Volvo',
];

// Popular models per make (not exhaustive — the field still accepts free text).
export const VEHICLE_MODELS = {
  Acura: ['ILX', 'Integra', 'MDX', 'RDX', 'TLX'],
  Audi: ['A3', 'A4', 'A5', 'A6', 'Q3', 'Q5', 'Q7', 'e-tron'],
  BMW: ['2 Series', '3 Series', '4 Series', '5 Series', 'X1', 'X3', 'X5', 'X7'],
  Buick: ['Enclave', 'Encore', 'Envision'],
  Cadillac: ['CT4', 'CT5', 'Escalade', 'XT4', 'XT5', 'XT6'],
  Chevrolet: ['Blazer', 'Camaro', 'Colorado', 'Equinox', 'Malibu', 'Silverado', 'Suburban', 'Tahoe', 'Trailblazer', 'Traverse', 'Trax'],
  Chrysler: ['300', 'Pacifica', 'Voyager'],
  Dodge: ['Challenger', 'Charger', 'Durango', 'Hornet'],
  Ford: ['Bronco', 'Edge', 'Escape', 'Expedition', 'Explorer', 'F-150', 'Mustang', 'Ranger', 'Transit'],
  GMC: ['Acadia', 'Canyon', 'Sierra', 'Terrain', 'Yukon'],
  Honda: ['Accord', 'Civic', 'CR-V', 'HR-V', 'Odyssey', 'Passport', 'Pilot', 'Ridgeline'],
  Hyundai: ['Elantra', 'Ioniq 5', 'Kona', 'Palisade', 'Santa Fe', 'Sonata', 'Tucson'],
  Infiniti: ['Q50', 'QX50', 'QX60', 'QX80'],
  Jeep: ['Cherokee', 'Compass', 'Gladiator', 'Grand Cherokee', 'Wrangler'],
  Kia: ['Carnival', 'Forte', 'K5', 'Seltos', 'Sorento', 'Soul', 'Sportage', 'Telluride'],
  Lexus: ['ES', 'GX', 'IS', 'NX', 'RX', 'UX'],
  Lincoln: ['Aviator', 'Corsair', 'Nautilus', 'Navigator'],
  Mazda: ['CX-30', 'CX-5', 'CX-50', 'CX-90', 'Mazda3', 'MX-5 Miata'],
  'Mercedes-Benz': ['A-Class', 'C-Class', 'E-Class', 'GLA', 'GLC', 'GLE', 'GLS'],
  Mini: ['Clubman', 'Countryman', 'Hardtop'],
  Mitsubishi: ['Eclipse Cross', 'Mirage', 'Outlander'],
  Nissan: ['Altima', 'Frontier', 'Kicks', 'Maxima', 'Murano', 'Pathfinder', 'Rogue', 'Sentra', 'Titan', 'Versa'],
  Porsche: ['911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  Ram: ['1500', '2500', '3500', 'ProMaster'],
  Rivian: ['R1S', 'R1T'],
  Subaru: ['Ascent', 'Crosstrek', 'Forester', 'Impreza', 'Legacy', 'Outback', 'WRX'],
  Tesla: ['Model 3', 'Model S', 'Model X', 'Model Y', 'Cybertruck'],
  Toyota: ['4Runner', 'Camry', 'Corolla', 'Highlander', 'Prius', 'RAV4', 'Sequoia', 'Sienna', 'Tacoma', 'Tundra'],
  Volkswagen: ['Atlas', 'Golf', 'ID.4', 'Jetta', 'Taos', 'Tiguan'],
  Volvo: ['S60', 'XC40', 'XC60', 'XC90'],
};

// All models flattened (used when no make is chosen yet, or the make is custom).
export const VEHICLE_MODELS_ALL = Array.from(new Set(Object.values(VEHICLE_MODELS).flat())).sort();

// Return the model suggestions for a given make (case/spacing tolerant), or the
// full flattened list if the make isn't recognized.
export function modelsForMake(make) {
  if (!make) return VEHICLE_MODELS_ALL;
  const key = Object.keys(VEHICLE_MODELS).find((m) => m.toLowerCase() === String(make).trim().toLowerCase());
  return key ? VEHICLE_MODELS[key] : VEHICLE_MODELS_ALL;
}

export const VEHICLE_COLORS = [
  'Black', 'White', 'Silver', 'Gray', 'Red', 'Blue', 'Dark Blue', 'Green', 'Brown',
  'Beige', 'Gold', 'Orange', 'Yellow', 'Burgundy', 'Tan', 'Charcoal',
];
